import React from 'react';
import PropTypes from 'prop-types';
import { I18n, Translate } from 'react-redux-i18n';
import { Icon, stringUtils, UploadDropzone } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const UploadPanelView = props => {
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: props.onSubmit,
    children: [/*#__PURE__*/_jsx("h2", {
      children: /*#__PURE__*/_jsx(Translate, {
        value: "request.documents.upload.title"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: stringUtils.getStrongs(I18n.t('request.documents.upload.notice', {
        documentName: props.document.type.label
      }))
    }), /*#__PURE__*/_jsx(UploadDropzone, {
      extensions: '.pdf',
      onDrop: props.onDrop,
      maxSize: props.maxSize,
      minSize: props.minSize,
      errorFileMessage: props.errorText
    }), props.fileName && /*#__PURE__*/_jsxs("div", {
      className: "information mt-4",
      children: [/*#__PURE__*/_jsx(Translate, {
        value: "document.filename"
      }), /*#__PURE__*/_jsx("strong", {
        children: props.fileName
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "actions col-12 inline-container space-between",
      children: [/*#__PURE__*/_jsxs("button", {
        type: "button",
        className: "large secondary inline-container",
        onClick: props.onClose,
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "action.cancel"
        }), /*#__PURE__*/_jsx(Icon, {
          icon: "go-back"
        })]
      }), /*#__PURE__*/_jsxs("button", {
        className: 'large cta inline-container',
        id: "submit",
        type: "submit",
        disabled: props.submitting,
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "action.confirm"
        }), /*#__PURE__*/_jsx(Icon, {
          icon: props.submitting ? 'loader' : 'check'
        })]
      })]
    })]
  });
};
UploadPanelView.propTypes = {
  document: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  fileName: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  minSize: PropTypes.number.isRequired,
  maxSize: PropTypes.number.isRequired
};
export default UploadPanelView;